export const pageSubHeaderCharacterProperties = {
    size: 15,
    bold: true,
    backColor: "#fff",
    underline: false,
    allCaps: false,
    italic: false,
    smallCaps: false,
    foreColor: "#000"
};
export const defaultCharacterProperties = {
    size: 12,
    bold: false,
    backColor: "NoColor",
    underline: false,
    allCaps: false,
    italic: false,
    smallCaps: false,
    foreColor: "#000"
};
